import ApplicationGrid from "Components/ApplicationGrid/ApplicationGrid";
import BusyLoading from "Components/Loading/BusyLoading/BusyLoading";
import Loader from "Components/Loading/Loader/Loader";
import MessageToaster from "Components/MessageToaster/MessageToaster";
import moment from "moment";
import "moment/locale/nl";
import qs from "query-string";
import * as React from "react";
import { connect } from "react-redux";
import { Switch } from "react-router-dom";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuthenticationAction } from "Store/Authentication/AuthenticationAction";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { ILoadingState } from "Store/Loading/LoadingActionTypes";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import Routes from "./Routes/Routes";

const authenticationAction = ServiceProvider.get<IAuthenticationAction>(Types.IAuthenticationAction);

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState,
    loadingState: state.loadingState
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    login: () => dispatch(authenticationAction.login()),
    updateTokenAsync: (token: string, companyId: number, route: string) => dispatch(authenticationAction.updateTokenAsync(token, companyId, route)),
});

interface IProps {
    authenticationState: IAuthenticationState;
    loadingState: ILoadingState;
    login(): Action;
    updateTokenAsync(token: string, companyId: number, route?: string): Action;
}

interface IQueryParams {
    token?: string;
    companyId?: number;
    route?: string;
}

interface IState {
    loading: boolean;
    isAuthorized: boolean;
    queryParams: IQueryParams;
}

class App extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            loading: true,
            isAuthorized: !!props.authenticationState.isAuthorized,
            queryParams: qs.parse(window.location.search),
        };

        moment.locale(i18n.language);
        this.updateTokenOrLogin();
    }

    public componentDidMount() {
        setTimeout(() => {
            this.setState({ loading: false });
        }, 500);
    }

    public static getDerivedStateFromProps(nextProps: IProps, state: IState): Partial<IState | null> {
        if (state.isAuthorized !== nextProps.authenticationState.isAuthorized) {
            return { isAuthorized: !!nextProps.authenticationState.isAuthorized };
        }
        return null;
    }

    private updateTokenOrLogin() {
        if (this.state.queryParams.token && this.state.queryParams.companyId) {
            this.props.updateTokenAsync(this.state.queryParams.token, this.state.queryParams.companyId, this.state.queryParams.route);
        }
        else if (!this.state.isAuthorized) {
            this.props.login();
        }
    }

    public render() {
        return (
            <>
                {
                    this.state.loading ?
                        <Loader />
                        :
                        <>
                            {this.state.isAuthorized ?
                                <ApplicationGrid>
                                    <Switch>
                                        <Routes />
                                    </Switch>
                                </ApplicationGrid>
                                :
                                <BusyLoading />
                            }
                            <MessageToaster />
                            {this.props.loadingState.loading && <BusyLoading />}
                        </>
                }
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.tsx